// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__8p8jZ","footer":"ReportModalFilter_footer__2PPbF"};